import { RedirectToSignIn, SignedOut, useAuth } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAtom } from 'jotai';
import * as React from 'react';
import { authAtom } from '~/atoms/authAtom';

export const Route = createFileRoute('/_authLayout/sign-in')({
  component: SignInPage,
});

function SignInPage() {
  const navigate = useNavigate();
  const [, setAuthStore] = useAtom(authAtom);

  const auth = useAuth();

  if (auth.isSignedIn && auth.isLoaded) {
    setAuthStore({ auth: auth });
    navigate({ to: '/' });
  }
  return (
    <>
      <SignedOut>
        <RedirectToSignIn signInForceRedirectUrl="/on-logged" />
      </SignedOut>
    </>
  );
}
